import {useTranslation} from 'react-i18next';
import Select from 'react-select';
import {Form} from 'react-bootstrap';
import {useSelector} from 'react-redux';
import {Scrollbar} from 'react-scrollbars-custom';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import BllinkUtils from '../../common/utils/utils';
import {StyledExpensesList} from './expenses.styled';
import {newSelectWithBorder} from '../../common/shared/select.styled';
import InputGroup from '../../common/InputGroup';
import ExpenseItemInput from './ExpenseItemInput';
import upload from '../../images/newDesign/upload.svg';
import bin from '../../images/newDesign/bin.svg';
import arrow from '../../images/newDesign/arrowWhite.svg';
import Checkbox from '../../common/simple/Checkbox';
import check from '../../images/newDesign/check.svg';
import listItemBg from '../../images/newDesign/coub5.svg';
import plus from '../../images/newDesign/plus.svg';
import Button from '../../common/Button';
import {Currency} from "../../common/currency";
import {fileToBase64} from "../../../utils/fileToBase64";

export default function ExpensesList({expenseRows, onChangeExpenseType, onRemoveLineClick, setData, months, onAddLine, onRecordClick, submitDisable}) {
    const {t} = useTranslation();
    const isLtrEnabled = useSelector(state => state.common.ltrEnabled);

    const onDeleteClick = (rowIndex) => {
        BllinkLogger.info(`expense row delete ${rowIndex}`)
        onRemoveLineClick(rowIndex);
    }

    const updateData = (rowIndex, field, value) => {
        let isValid = true;
        let error = '';

        if (field === 'amount') {
            isValid = BllinkUtils.JsExtras.isNumeric(value) && value > 0;
            error = isValid ? '' : t('reports.fieldError', {field});
        }

        setData(rowIndex, field, value, error);
    }

    const getFile = async (evt, index) => {
        const files = evt.target.files;
        if (files && files[0]) {
            const fileBase64 = await fileToBase64(files[0]);
            const fileName = files[0].name;
            updateData(index, 'invoiceFile', { fileName, fileBase64 });
        }
    }

    const onFileChange = (evt, index) => {
        if ( evt.target.files &&  evt.target.files[0]) {
            let sizeInMB = evt.target.files[0].size / 1000 / 1000;
            if ( sizeInMB > 2) {
                alert(t('expenses.file_size_error'));
                return;
            }

            getFile(evt, index);
        }
    };

    const totalAmount = BllinkUtils.Money.roundNumber(expenseRows.map((e) => parseFloat(e.amount)).reduce((a, b) => a + b, 0));

    return (
        <StyledExpensesList>
            <Scrollbar
                style={{ width: '100%', height: 'calc(100vh - 450px)' }}
                trackYProps={{
                    renderer: props => {
                        const { elementRef, ...restProps } = props;
                        return <div {...restProps} ref={elementRef} className="scroll-track" />;
                    }
                }}
                thumbYProps={{
                    renderer: props => {
                        const { elementRef, ...restProps } = props;
                        return <div {...restProps} ref={elementRef} className="scroll-thumb" />;
                    }
                }}
                rtl={false}
                noScrollX
            >
                <ul className='expenses'>
                    {expenseRows.map((item, index) => {
                        const selectVal = item.expenseTypes?.expenseTypeID.value ? item.expenseTypes?.expenseTypeID : item.expenseTypes?.all[0];
                        return (
                            <li
                                key={index}
                                className='expense-item'
                            >
                                <div className='expense-item-row'>
                                    <div className={'bg'}>
                                        <img src={listItemBg} alt="bg" />
                                    </div>
                                    <div className='type'>
                                        <InputGroup
                                            labelContent={index > 0 && (
                                                <>
                                                    <img
                                                        className='label-icon'
                                                        src={bin}
                                                        alt="bin"
                                                        onClick={() => onDeleteClick(index)}
                                                    />
                                                    <span>{t('expenses.expense_record_table_type')}</span>
                                                </>
                                            )}
                                            labelText={index === 0 && t('expenses.expense_record_table_type')}
                                            withBorder
                                            alignStart
                                        >
                                            <Select
                                                id={`expense-type-${index}`}
                                                className={'js-expense-type'}
                                                styles={newSelectWithBorder}
                                                options={item.expenseTypes ? item.expenseTypes.all : []}
                                                value={selectVal}
                                                menuPortalTarget={document.querySelector('body')}
                                                onChange={val => onChangeExpenseType(val, index)}
                                                withBorder
                                            />
                                        </InputGroup>
                                    </div>
                                    <div className='amount-block'>
                                        <ExpenseItemInput
                                            index={index}
                                            errors={item.errors}
                                            fieldName={'invoiceNum'}
                                            initialValue={item.invoiceNum}
                                            labelText={t('expenses.expense_record_table_invoice')}
                                            updateData={updateData}
                                        />

                                        <ExpenseItemInput
                                            index={index}
                                            errors={item.errors}
                                            fieldName={'amount'}
                                            initialValue={item.amount}
                                            labelText={t('expenses.expense_record_table_amount')}
                                            updateData={updateData}
                                        />

                                        <InputGroup
                                            labelText={t('expenses.expense_record_table_upload')}
                                            classes={'file-upload'}
                                            withBorder
                                        >
                                            {
                                                item.invoiceFile?.fileName ? <span className={'file-name'}>{item.invoiceFile.fileName}</span> : <img alt="upload file" src={upload} />
                                            }
                                            <Form.Control
                                                type="file"
                                                accept=".jpg,.jpeg,.png,.pdf"
                                                name={'receipt'}
                                                className={'file_upload-input'}
                                                onChange={e => onFileChange(e, index)}
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                                <div className='expense-item-row with-period'>
                                    <InputGroup
                                        labelContent={(
                                            <>
                                                <Checkbox
                                                    checked={item.isPeriodChecked}
                                                    onChange={value => updateData(index, 'isPeriodChecked', value)}
                                                    name={'vendor'}
                                                    icon={<img src={check} alt="check" />}
                                                    borderColor="#7D97FF"
                                                    borderWidth={1}
                                                    borderRadius={4}
                                                    style={{ overflow: "hidden" }}
                                                    size={16}
                                                />
                                                <span>{t('expenses.expense_record_table_period')}</span>
                                            </>
                                        )}
                                        classes={'with-icon'}
                                        withBorder
                                    >
                                        <div className={item.isPeriodChecked ? 'period' : 'period disabled'}>
                                            <div className='period-item'>
                                                <label>{t('expenses.expense_record_table_from')}</label>
                                                <Select
                                                    id={`expense-from-${index}`}
                                                    styles={newSelectWithBorder}
                                                    options={months}
                                                    value={item.from || months[0]}
                                                    menuPortalTarget={document.querySelector('body')}
                                                    onChange={val => updateData(index, 'from', val)}
                                                />
                                            </div>
                                            <div className='period-item'>
                                                <label>{t('expenses.expense_record_table_to')}</label>
                                                <Select
                                                    id={`expense-to-${index}`}
                                                    styles={newSelectWithBorder}
                                                    options={months}
                                                    value={item.to || months[1]}
                                                    menuPortalTarget={document.querySelector('body')}
                                                    onChange={val => updateData(index, 'to', val)}
                                                />
                                            </div>
                                        </div>
                                    </InputGroup>
                                    <ExpenseItemInput
                                        index={index}
                                        errors={item.errors}
                                        className={'description'}
                                        fieldName={'description'}
                                        initialValue={item.description}
                                        labelText={t('expenses.description')}
                                        updateData={updateData}
                                    />
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </Scrollbar>
            <div className='add-row' onClick={onAddLine}>
                <img src={plus} alt="add" />
            </div>

            <div className='result'>
                <div className={'total'}>
                    <span>{t('expenses.total_amount')}</span>
                    {/* TODO: warning! hardcoded currency detected */}
                    <span>{BllinkUtils.Strings.numberWithCommas(totalAmount)} <Currency>{'ILS'}</Currency></span>
                </div>
                <Button
                    type={'button'}
                    onClick={onRecordClick}
                    rounded
                    fontBig
                    rtl={!isLtrEnabled}
                    disabled={submitDisable}
                >
                    
                    {t('expenses.record_expense')}
                    <div className='btn-icon'>
                        <img src={arrow} alt="arrow" />
                    </div>
                </Button>
            </div>
        </StyledExpensesList>
    );
}
